import React from "react";
import { GetCompliantPageWrapper } from "../../../components/layout/GetCompliantPageWrapper";
import { DomainSetupCard } from "../../../components/superorg/settings/DomainSetupCard";

export const VerifySubdomainPage: React.FC = () => {
  return (
    <GetCompliantPageWrapper>
      <div className="tw-boundary">
        <div className="mx-auto flex w-[890px] max-w-full flex-col items-center">
          <div className="w-full text-center text-[30px] font-bold leading-[45px] text-primary-800">
            Let’s set up your privacy email and a custom domain for your Privacy Center
          </div>
          <div className="mt-[12px] w-full text-center text-[20px] font-medium leading-[30px] text-primary-800">
            Your privacy email will be used to receive and respond to privacy requests received from
            your new Privacy Center site where users can submit privacy requests.
          </div>
        </div>

        <div className="mx-auto mt-[24px] w-[890px] max-w-full">
          <DomainSetupCard className="max-w-full" />
        </div>
      </div>
    </GetCompliantPageWrapper>
  );
};
